import api from "../../services/api.js";
import { getNested, isEmpty } from "../../utils/utils";
// import  isEmpty  from "lodash/isEmpty";
import * as UltrixData from "../UltrixData.js";
import Vue from "vue";

const defaultState = () => {
  return {
    profileData: {
      contact: {},
      payload: {},
      token: "",
      version: "",
    },
    isLoading: false,
  };
};

function getPartData(arr) {
  let arr2 = arr.map((obj) => {
    return { item: obj.item, desc: obj.desc, qty: obj.qty };
  });
  return arr2;
}
const parts = () => {
  //concatenate UltrixDate parts as thats how they are in profile
  let parts = [];
  // parts.push(...getPartData(UltrixData.frameParts));
  parts.push(...UltrixData.frameParts);
  // parts.push(...getPartData(UltrixData.controlParts));
  parts.push(...UltrixData.controlParts);
  // parts.push(...getPartData(UltrixData.installParts));
  parts.push(...UltrixData.installParts);
  return parts;
};
function getTodayTime() {
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = today.getFullYear();
  let hh = today.getHours();
  let min = String(today.getMinutes()).padStart(2, "0");
  return hh + ":" + min + " " + mm + "/" + dd + "/" + yyyy;
}
export function updateSwitcher(incoming) {
  let updated = [];
  if (incoming.length > 0) {
    incoming.forEach((part) => {
      //find in UltrixData
      outerloop: for (const series in UltrixData.switcherParts) {
        if (Object.hasOwn(UltrixData.switcherParts, series)) {
          const seriesCategories = UltrixData.switcherParts[series];
          for (const categ in seriesCategories) {
            if (Object.hasOwn(seriesCategories, categ)) {
              let found = seriesCategories[categ].find(
                (arrItem) => arrItem.item === part.item
              );
              if (found) {
                let newPart = {};
                //if found is obs find substitue
                if (found.obsolete == true) {
                  if (found.substitute != "") {
                    newPart = seriesCategories[categ].find(
                      (arrItem) => arrItem.item === found.substitute
                    );
                  }
                } else {
                  newPart = JSON.parse(JSON.stringify(found));
                }
                if (newPart.item) {
                  updated.push({
                    item: newPart.item,
                    desc: newPart.desc,
                    qty: part.qty,
                  });
                }

                //if found break
                break outerloop;
              }
            }
          }
        }
      }
    });
  }
  return updated;
}
function updateParts(incomingParts) {
  let updated = [];
  if (incomingParts.length > 0) {
    let ultrixDataParts = parts();

    for (let p = 0; p < ultrixDataParts.length; p++) {
      let part = ultrixDataParts[p];

      let partIndex = incomingParts.findIndex(
        (profilePart) => profilePart.item === part.item
      );
      let obsolete = getNested(ultrixDataParts[p], "obsolete");
      if (partIndex > -1) {
        //does it have substitute?

        if (obsolete) {
          let substitute = getNested(ultrixDataParts[p], "substitute");
          let subPart;
          if (substitute && substitute.length > 0) {
            subPart = ultrixDataParts.find((p) => p.item === substitute);
          }
          if (subPart) {
            part = subPart;
          } else {
            part = ultrixDataParts[p];
          }
        }

        //incoming profile has this part so copy qty
        part.qty = incomingParts[partIndex].qty;

        updated.push(JSON.parse(JSON.stringify(part)));
      } else {
        // have we already added part through substitute path?
        let updatedIndex = updated.findIndex(
          (updatedPart) => updatedPart.item === part.item
        );
        if (updatedIndex == -1 && !obsolete) {
          updated.push(JSON.parse(JSON.stringify(part)));
        }
      }
    }
  }
  return updated.map((obj) => {
    return { item: obj.item, desc: obj.desc, qty: obj.qty };
  });
  // return updated;
}
function updateSfp(incomingSfpModel) {
  // returns new sfp object
  let newSfp = {};
  const sfpModIndex = UltrixData.SFP.findIndex(
    ({ model }) => model === incomingSfpModel
  );
  if (sfpModIndex > -1) {
    //we found a match
    if (UltrixData.SFP[sfpModIndex].obsolete == true) {
      //is obsolete set to true
      if (UltrixData.SFP[sfpModIndex].substitute.length > 0) {
        //is there a substitute
        const subIdx = UltrixData.SFP.findIndex(
          ({ type }) => type === UltrixData.SFP[sfpModIndex].substitute
        );
        if (subIdx > -1) {
          //we found substitute
          newSfp = JSON.parse(JSON.stringify(UltrixData.SFP[subIdx]));
        }
      }
    } else {
      newSfp = JSON.parse(JSON.stringify(UltrixData.SFP[sfpModIndex]));
    }
  }
  return newSfp;
}
function updateModule(incomingModuleModel) {
  //returns new subModule
  let newModule = {};
  let _incomingModuleModel = incomingModuleModel;
  if (incomingModuleModel === "ULTRIX-MODX-SFP")
    _incomingModuleModel = "ULTRIX-MOD-SFP";
  if (incomingModuleModel === "ULTRIX-MODX-SDI")
    _incomingModuleModel = "ULTRIX-MOD-SDI";

  const newModuleIndex = UltrixData.modularIOModules.findIndex(
    ({ model }) => model === _incomingModuleModel
  );
  if (newModuleIndex > -1) {
    //we found a match
    if (UltrixData.modularIOModules[newModuleIndex].obsolete == true) {
      //is obsolete set to true
      if (UltrixData.modularIOModules[newModuleIndex].substitute.length > 0) {
        //is there a substitute
        const subIdx = UltrixData.modularIOModules.findIndex(
          ({ type }) =>
            type === UltrixData.modularIOModules[newModuleIndex].substitute
        );
        if (subIdx > -1) {
          //we found substitute
          newModule = JSON.parse(
            JSON.stringify(UltrixData.modularIOModules[subIdx])
          );
        }
      }
    } else {
      newModule = JSON.parse(
        JSON.stringify(UltrixData.modularIOModules[newModuleIndex])
      );
    }
  }
  return newModule;
}
function modxioPortMapping(portName) {
  //portNum or bncNum (string) to modxio mapping
  let nums = portName.match(/(\d+)/);
  if (nums) {
    let pNum = Number(nums[0]);
    let col = pNum % 4;
    let row = col == 0 ? Math.floor(pNum / 4) - 1 : Math.floor(pNum / 4);
    let lookup = [
      ["slotA.port4", "slotB.port4", "slotC.port4", "slotD.port4"],
      ["slotA.port1", "slotB.port1", "slotC.port1", "slotD.port1"],
      ["slotA.port2", "slotB.port2", "slotC.port2", "slotD.port2"],
      ["slotA.port3", "slotB.port3", "slotC.port3", "slotD.port3"],
    ];
    return lookup[col][row];
  }
  return portName;
}

export const methods = {
  updateProfileData(data) {
    // console.log("update profileData");

    let profilePayload = {};

    const requests = getNested(data.payload, "requests");
    if (!Array.isArray(data.payload) && requests != undefined) {
      const numRequests = Object.keys(requests).length;
      for (let r = 1; r < numRequests + 1; r++) {
        // console.log("request:" + r, "total:", numRequests);

        if (!Object.hasOwn(profilePayload, "requests")) {
          profilePayload["requests"] = {};
        }

        //name/date changing
        //if date/status fields do not exist,
        //new name = 'Request created'
        //new date = 'HH:MM mm/dd/yyyy'
        //new Sattus = 'upgraded'
        let newName, newDate, newStatus;
        //is name of 'Request created HH:MM mm/dd/yyyy' format?
        const regex = new RegExp(/(?:\d+:\d{2} \d{2}.*\/\d\d.*\/\d{4})$/);

        // request.date does not exist, refactor name,date and status fields
        if (typeof data.payload.requests[r].date == "undefined") {
          let test = data.payload.requests[r].name.search(regex);
          if (test > -1) {
            newName = data.payload.requests[r].name.substring(0, test);
            newDate = data.payload.requests[r].name.substring(test);
            newStatus = "Updated";
          }
        } else {
          newName = data.payload.requests[r].name;
          newDate = data.payload.requests[r].date;
          newStatus = data.payload.requests[r].status;
        }

        Object.assign(profilePayload.requests, {
          [r]: {
            id: data.payload.requests[r].id,
            name: newName,
            date: newDate,
            status: newStatus,
            legacy: "false",
          },
        });

        /*************sevices*********/

        if (!Object.hasOwn(profilePayload.requests[r], "services")) {
          //if services array doesnt exit, create it
          profilePayload.requests[r]["services"] = [];
        }
        //copy default services array
        Object.assign(
          profilePayload.requests[r].services,
          JSON.parse(JSON.stringify(UltrixData.services))
        );
        //does incoming profile already have services array?
        if (Object.hasOwn(data.payload.requests[r], "services")) {
          //loop through new profile services to match incoming profile service andn copy qty
          profilePayload.requests[r].services.forEach((service) => {
            //get item=service.item
            let s = data.payload.requests[r].services.find(
              ({ item }) => item === service.item
            );
            if (s !== undefined) {
              //incoming profile has this part so copy qty
              service.qty = s.qty;
            }
          });
        }
        /*************** end services****************/
        let numChassis = Object.keys(data.payload.requests[r].chassis).length;
        for (let c = 1; c < numChassis + 1; c++) {
          // console.log("chassis:" + c);
          // let chassis = data.payload.requests[r].chassis[c];
          if (!Object.hasOwn(profilePayload.requests[r], "chassis")) {
            profilePayload.requests[r]["chassis"] = {};
          }
          profilePayload.requests[r].chassis[c] = {};
          Object.assign(profilePayload.requests[r].chassis[c], {
            name: data.payload.requests[r].chassis[c].name,
          });

          //iterate over chassis frame

          //model:type map
          // let reg = /\d+/;
          const frameModel = data.payload.requests[r].chassis[c].frame.model;
          if (frameModel == "ULTRIX-FR5") {
            //set legacy flag
            profilePayload.requests[r].legacy = "true";
          }
          //const frameSize = reg.exec(frameModel);
          //const fm = "ULTRIX_FR" + frameSize; //"ULTRIX_" + frameModel.slice(frameModel.length - 3);
          const fm = frameModel.replace(/-/g, "_");
          const f = JSON.parse(JSON.stringify(UltrixData[fm]));

          // console.log("fm:" + fm, "f:" + { f });
          Object.assign(profilePayload.requests[r].chassis[c], {
            frame: f,
          });

          //**************************Iterate over frameLicenses**********************/
          const frameLicenses =
            data.payload.requests[r].chassis[c].frame.frameLicenses;
          for (const lic of frameLicenses) {
            const licType = lic.item.replace("_", "-");
            //if licType is in UltrixData.frame,copy qty
            const idx = profilePayload.requests[r].chassis[
              c
            ].frame.frameLicenses.findIndex((l) => l.item === licType);
            if (idx > -1) {
              profilePayload.requests[r].chassis[c].frame.frameLicenses[
                idx
              ].qty = lic.qty;
            }
            //else copy license obj
            else {
              profilePayload.requests[r].chassis[c].frame.frameLicenses.push(
                JSON.parse(JSON.stringify(lic))
              );
            }
          }
          //
          /********************** iterate over frame modules *****************************/
          const frameModules =
            data.payload.requests[r].chassis[c].frame.modules;
          let modxPresent = false; //assume no modx in frame to loop through
          for (const slot in frameModules) {
            if (Object.hasOwn(frameModules, slot)) {
              let newModule, ioMod;

              if (
                (isEmpty(frameModules[slot]) ||
                  getNested(frameModules[slot], "type") == "BLANK") &&
                slot.includes("slot")
              ) {
                //replace empty module objects with BLANK
                ioMod = UltrixData.ioModules.find(
                  (ioModule) => ioModule.type === "BLANK"
                );
                profilePayload.requests[r].chassis[c].frame.modules[slot] =
                  JSON.parse(JSON.stringify(ioMod));
                continue;
              }
              if (
                slot.includes("macd") &&
                frameModules[slot]?.model &&
                frameModules[slot].model == "ULTRIX-IO-BP"
              ) {
                //fix error when ULTRIX-IO-BP are fitted to MACD
                profilePayload.requests[r].chassis[c].frame.modules[slot] = {};
                continue;
              }
              if (!frameModules[slot]?.model) {
                continue;
              }
              switch (frameModules[slot].model) {
                case "ACUFR-VIDPROC":
                  // version 8.6->8.7 model:ACUFR-VIDPROC, type:ACUFR changed to model:SWP-SDPE, type:Acuity
                  ioMod = UltrixData.ioModules.find(
                    (ioModule) => ioModule.type === "Acuity"
                  );
                  break;
                case "ACUFR-CPU":
                  ioMod =
                    frameModel == "ULTRIX-FR12"
                      ? UltrixData.ACUFR12_CPU
                      : UltrixData.ACUFR_CPU;
                  break;
                case "ACUFR12-CPU":
                  ioMod = UltrixData.ACUFR12_CPU;
                  break;
                case "CHMFR5-CPU":
                  ioMod = UltrixData.CHMFR5_CPU;
                  break;
                case "CHMFR5NS-CPU":
                  ioMod = UltrixData.CHMFR5NS_CPU;
                  break;
                case "CHMFR12-CPU":
                  ioMod = UltrixData.CHMFR12_CPU;
                  break;
                case "SWR-SDPE":
                  ioMod = UltrixData.ioModules.find(
                    (ioModule) => ioModule.type === frameModules[slot].type
                  );
                  break;
                default:
                  ioMod = UltrixData.ioModules.find(
                    (ioModule) => ioModule.model === frameModules[slot].model
                  );
                  break;
              }
              if (getNested(ioMod, "obsolete")) {
                //module is obsolete, need to replace with substitue

                if (getNested(ioMod, "substitute") != "") {
                  ioMod = UltrixData.ioModules.find(
                    (ioModule) => ioModule.model === ioMod.substitute
                  );
                } else {
                  //no substitute
                  ioMod = UltrixData.ioModules.find(
                    (ioModule) => ioModule.type === "BLANK"
                  );
                }
              }

              if (ioMod != undefined) {
                newModule = JSON.parse(JSON.stringify(ioMod));
                Object.assign(
                  profilePayload.requests[r].chassis[c].frame.modules[slot],
                  newModule
                );
                // profilePayload.requests[r].chassis[c].frame.modules[slot] =
                //   newModule;

                //are we upgrading SFPIO to MODXIO?
                let sfpioUpgrade = false;

                if (
                  frameModules[slot].model === "ULTRIX-SFP-IO" &&
                  ioMod.model === "ULTRIX-MODX-IO"
                ) {
                  //add sfp submodules
                  sfpioUpgrade = true;
                  const sfpIOioMod = UltrixData.modularIOModules.find(
                    (ioModule) => ioModule.model === "ULTRIX-MOD-SFP"
                  );
                  for (const subModPos in newModule.modules) {
                    if (Object.hasOwn(newModule.modules, subModPos)) {
                      // const element = newModule.modules[subModPos];
                      Object.assign(
                        profilePayload.requests[r].chassis[c].frame.modules[
                          slot
                        ].modules[subModPos],
                        JSON.parse(JSON.stringify(sfpIOioMod))
                      );
                    }
                  }
                }
                /************ iterate module license assignments *******************************/
                if (Object.hasOwn(frameModules[slot], "ultriscapeLicenses")) {
                  let newUscapePos = [];
                  if (frameModules[slot].model != newModule.model) {
                    // if we obsoleted incoming module, loop assignments to ensure match - in case of board upgrade (HDBNC > HDXIO)

                    const oldUscapeAssignments = [
                      ...frameModules[slot].ultriscapeLicenses,
                    ];
                    oldUscapeAssignments.forEach((el) => {
                      switch (el) {
                        case "BNC7":
                          newUscapePos.push("BNC5");
                          break;

                        case "BNC11":
                          newUscapePos.push("BNC13");
                          break;
                        case "port5":
                          if (sfpioUpgrade) {
                            newUscapePos.push("slotB.port1");
                            break;
                          }
                        case "port7":
                          if (sfpioUpgrade) {
                            newUscapePos.push("slotB.port1");
                            break;
                          }
                        case "port11":
                        case "port13":
                          if (sfpioUpgrade) {
                            newUscapePos.push("slotD.port1");
                            break;
                          }
                        case "Out9":
                          newUscapePos.push("Out5");
                          break;
                        default:
                          newUscapePos.push(el);
                          break;
                      }
                    });
                  } else {
                    newUscapePos = frameModules[slot].ultriscapeLicenses;
                  }

                  Object.assign(
                    profilePayload.requests[r].chassis[c].frame.modules[slot],
                    {
                      ultriscapeLicenses: newUscapePos,
                    }
                  );
                }

                if (Object.hasOwn(frameModules[slot], "ultrisyncLicenses")) {
                  Object.assign(
                    profilePayload.requests[r].chassis[c].frame.modules[slot],
                    {
                      ultrisyncLicenses: frameModules[slot].ultrisyncLicenses,
                    }
                  );
                }
                if (Object.hasOwn(frameModules[slot], "ultrisrcLicenses")) {
                  Object.assign(
                    profilePayload.requests[r].chassis[c].frame.modules[slot],
                    {
                      ultrisrcLicenses: frameModules[slot].ultrisrcLicenses,
                    }
                  );
                }
                if (Object.hasOwn(frameModules[slot], "ultrisyncUhdLicenses")) {
                  let newUsyncUPos = [];
                  if (frameModules[slot].model != newModule.model) {
                    // if we obsoleted incoming module, loop assignments to ensure match - in case of board upgrade (HDBNC > HDXIO)
                    const oldUsyncAssignments = [
                      ...frameModules[slot].ultrisyncUhdLicenses,
                    ];
                    oldUsyncAssignments.forEach((el) => {
                      switch (el) {
                        case "BNC6":
                          newUsyncUPos.push("BNC7");
                          break;
                        case "BNC12":
                          newUsyncUPos.push("BNC13");
                          break;
                        case "port1":
                          if (sfpioUpgrade) {
                            newUsyncUPos.push("slotA.port1");
                            break;
                          }
                        case "port5":
                          if (sfpioUpgrade) {
                            newUsyncUPos.push("slotB.port1");
                            break;
                          }
                        case "port6":
                          if (sfpioUpgrade) {
                            newUsyncUPos.push("slotB.port3");
                            break;
                          }
                        case "port11":
                          if (sfpioUpgrade) {
                            newUsyncUPos.push("slotC.port3");
                            break;
                          }
                        case "port12":
                          if (sfpioUpgrade) {
                            newUsyncUPos.push("slotD.port1");
                            break;
                          }
                        case "AUXB":
                          if (
                            newUsyncUPos.includes("slotB.port1") ||
                            newUsyncUPos.includes("slotB.port3")
                          ) {
                            newUsyncUPos.push("AUXA");
                          } else {
                            newUsyncUPos.push("AUXB");
                          }

                          break;
                        default:
                          newUsyncUPos.push(el);
                          break;
                      }
                    });
                  } else {
                    newUsyncUPos = frameModules[slot].ultrisyncUhdLicenses;
                  }
                  Object.assign(
                    profilePayload.requests[r].chassis[c].frame.modules[slot],
                    {
                      ultrisyncUhdLicenses: newUsyncUPos,
                    }
                  );
                }
                if (Object.hasOwn(frameModules[slot], "meLicense")) {
                  //meLicense is now licenses.format as at v8.8
                  Object.assign(
                    profilePayload.requests[r].chassis[c].frame.modules[slot]
                      .licenses.format,
                    {
                      value: frameModules[slot].meLicense[0],
                    }
                  );
                }

                if (Object.hasOwn(frameModules[slot], "licenses")) {
                  //loop through new profile module licenses to match incoming profile and copy qty
                  let incomingSlotLicenses = frameModules[slot].licenses;

                  for (let license in incomingSlotLicenses) {
                    if (Object.hasOwn(incomingSlotLicenses, license)) {
                      //match incoming license with new profile license
                      let newLicenseNames = Object.keys(
                        profilePayload.requests[r].chassis[c].frame.modules[
                          slot
                        ].licenses
                      );

                      if (license === "format") {
                        // if old format:{value:'HD-ME'} detected upgrade to indiv. licenses
                        if (incomingSlotLicenses[license].value === "HD-ME") {
                          profilePayload.requests[r].chassis[c].frame.modules[
                            slot
                          ].licenses["HD-ME"].qty = 1;
                          profilePayload.requests[r].chassis[c].frame.modules[
                            slot
                          ].licenses["UHD-ME"].qty = 0;
                        }
                        if (incomingSlotLicenses[license].value === "UHD-ME") {
                          profilePayload.requests[r].chassis[c].frame.modules[
                            slot
                          ].licenses["HD-ME"].qty = 0;
                          profilePayload.requests[r].chassis[c].frame.modules[
                            slot
                          ].licenses["UHD-ME"].qty = 1;
                        }
                      }

                      if (slot == "slot0") {
                        if (license == "ultrimixDante") {
                          //remove for slot0 : v10.02 allowed aux C in error
                          //continue with empty default license
                          continue;
                        }
                      }
                      if (
                        newLicenseNames.includes(license) &&
                        getNested(
                          incomingSlotLicenses[license],
                          "positions",
                          "length"
                        ) > 0
                        // incomingSlotLicenses[license]?.qty
                      ) {
                        profilePayload.requests[r].chassis[c].frame.modules[
                          slot
                        ].licenses[license].positions =
                          incomingSlotLicenses[license].positions;
                      }
                    }
                  }
                }

                if (Object.hasOwn(frameModules[slot], "modules")) {
                  //flag update from BLANKS TO BAFFLE-BLANKS
                  modxPresent = true;
                  //iterate subModules

                  let incomingSubModules = getNested(
                    frameModules[slot],
                    "modules"
                  );
                  if (incomingSubModules) {
                    for (const subModulePos in incomingSubModules) {
                      if (Object.hasOwn(incomingSubModules, subModulePos)) {
                        const subModule = incomingSubModules[subModulePos];
                        if (subModule.model) {
                          let newModule = updateModule(subModule.model);
                          Object.assign(
                            profilePayload.requests[r].chassis[c].frame.modules[
                              slot
                            ].modules[subModulePos],
                            newModule
                          );
                        }
                        //any subModule sfpPorts?
                        let sfpPorts = getNested(subModule, "sfpPorts");
                        if (sfpPorts) {
                          for (const port in sfpPorts) {
                            if (Object.hasOwn(sfpPorts, port)) {
                              const sfpModel = sfpPorts[port].model;
                              let newSFP = updateSfp(sfpModel);
                              Object.assign(
                                profilePayload.requests[r].chassis[c].frame
                                  .modules[slot].modules[subModulePos].sfpPorts[
                                  port
                                ],
                                newSFP
                              );
                            }
                          }
                        }
                      }
                    }
                  }
                }

                //
                /********************* sfp assignments *********************/
                const sfpModules = getNested(
                  data.payload.requests[r].chassis[c].frame.modules[slot],
                  "sfpPorts"
                );

                if (sfpModules) {
                  for (const pos in sfpModules) {
                    if (Object.hasOwn(sfpModules, pos)) {
                      let newSfp;
                      if (!getNested(sfpModules[pos], "model")) {
                        continue; //if no sfp present then skip ahead
                      }
                      if (slot == "slot0") {
                        if (pos.includes("AUXB") || pos.includes("AUXC")) {
                          //remove any auxB or aucC sfp in flex slot
                          newSfp = {};
                          Object.assign(
                            profilePayload.requests[r].chassis[c].frame.modules[
                              slot
                            ].sfpPorts[pos],
                            newSfp
                          );
                          continue;
                        }
                      }
                      newSfp = updateSfp(sfpModules[pos].model);

                      let arr = sfpioUpgrade
                        ? modxioPortMapping(pos).split(".")
                        : [pos];

                      if (arr.length > 1) {
                        Object.assign(
                          profilePayload.requests[r].chassis[c].frame.modules[
                            slot
                          ].modules[arr[0]].sfpPorts[arr[1]],
                          newSfp
                        );
                      } else {
                        Object.assign(
                          profilePayload.requests[r].chassis[c].frame.modules[
                            slot
                          ].sfpPorts[arr[0]],
                          newSfp
                        );
                      }
                    }
                  }
                }
              }
            }
          } //end frame modules

          /*****************  iterate over UltrixData frame and install parts *************************/
          // console.log("req", r, " cha", c);
          const incomingChassisParts =
            data.payload.requests[r].chassis[c].parts;

          Object.assign(profilePayload.requests[r].chassis[c], {
            parts: updateParts(incomingChassisParts),
          });

          //iterate over incoming profile BCS parts
          let BCSitems = incomingChassisParts.filter(
            (profPart) => profPart.item === "ULTRICORE-BCS"
          );

          //if BCS enabled update ultricore-ember+ and pro and nvision licenses to BCS

          const list = [
            "ULTRICORE-EMBER+",
            "ULTRICORE-NVISION",
            "ULTRICORE-PRO",
          ];
          let updatedParts = profilePayload.requests[r].chassis[c].parts;
          let ucoreLics = JSON.parse(
            JSON.stringify(updatedParts.filter((pt) => list.includes(pt.item)))
          );

          if (BCSitems.length > 0 || frameModel === "ULTRIX-FR12") {
            //
            //if BCS or FR12 set ucoreLics = 0

            list.forEach((license) => {
              let idx = updatedParts.findIndex((o) => o.item === license);
              if (idx > -1) {
                updatedParts[idx].qty = 0;
              }
            });
          }

          for (let b = 0; b < BCSitems.length; b++) {
            const oldBCS = BCSitems[b];
            const newBCS = Object.assign(
              {},
              JSON.parse(JSON.stringify(UltrixData.BCS))
            );
            newBCS.id = oldBCS.id;
            newBCS.qty = oldBCS.qty;
            //iterate licenses
            for (const license in newBCS.licenses) {
              // const licDetails = newBCS.licenses[license];
              if (oldBCS.licenses?.[license]) {
                //if incoming BCS has license that also in new BCS, equte the qty
                newBCS.licenses[license].qty = oldBCS.licenses[license].qty;
              }
              if (newBCS.id === 1) {
                let ucoreLicQty = ucoreLics.find((l) => l.item === license);
                if (ucoreLicQty) {
                  newBCS.licenses[license].qty = ucoreLicQty.qty;
                }
              }
            }

            profilePayload.requests[r].chassis[c].parts.push(
              JSON.parse(JSON.stringify(newBCS))
            );
          }
          //iterate over request.chassis.switcher
          let sw = [];
          if (Object.hasOwn(data.payload.requests[r].chassis[c], "switchers")) {
            sw = updateSwitcher(data.payload.requests[r].chassis[c].switchers);
          }
          Object.assign(profilePayload.requests[r].chassis[c], {
            switchers: sw,
          });

          if (modxPresent === true) {
            //need to update blanks to baffle-blanks
            let baf = UltrixData.ioModules.find(
              (ioModule) => ioModule.model === "ULTRIX-IO-BAF"
            );
            let macdbaf = UltrixData.ioModules.find(
              (ioModule) => ioModule.model === "ULTRIX-MACD-BAF"
            );
            let fModules = profilePayload.requests[r].chassis[c].frame.modules;
            let newBlank = {};
            for (const slot in fModules) {
              if (Object.hasOwn(fModules, slot)) {
                const item = fModules[slot];
                // console.log(item, slot);
                if (item?.type && item.type.includes("BLANK")) {
                  if (slot.includes("slot")) {
                    newBlank = JSON.parse(JSON.stringify(baf));
                  }
                  if (slot == "macd") {
                    newBlank = JSON.parse(JSON.stringify(macdbaf));
                  }
                  Object.assign(
                    profilePayload.requests[r].chassis[c].frame.modules[slot],
                    newBlank
                  );
                }
                if (slot == "macd" && !item.type) {
                  newBlank = JSON.parse(JSON.stringify(macdbaf));
                  Object.assign(
                    profilePayload.requests[r].chassis[c].frame.modules[slot],
                    newBlank
                  );
                }
              }
            }
            //UCCI-BAF
            if (frameModel == "ULTRIX-FR5" || frameModel == "ULTRIX-NS-FR5") {
              let profParts = profilePayload.requests[r].chassis[c].parts;
              let uccipres = profParts.find((i) => i.item === "ULTRIX-UCCI");

              if (uccipres && uccipres.qty == 0) {
                //get ucci-baf index
                let bafidx = profParts.findIndex(
                  (p) => p.item === "ULTRIX-UCCI-BAF"
                );

                if (bafidx > -1) {
                  profParts[bafidx] = {
                    item: "ULTRIX-UCCI-BAF",
                    desc: "Blanking plate baffle - UCCI slot",
                    qty: 1,
                  };
                }
              }
            }
          }
        }
      } // console.log("request-end:", r, "total:", numRequests);
      return {
        contact: data.contact,
        payload: profilePayload,
        token: data.token,
        version: UltrixData.dataVersion,
      };
    } else {
      return {
        contact: data.contact,
        payload: data.payload,
        token: data.token,
        version: UltrixData.dataVersion,
      };
    }
    // }
  },
};
export const namespaced = true;
export const state = defaultState();
export const getters = {
  getIsLoading(state) {
    return state.isLoading;
  },
  getRequestName(state) {
    return (request_id) => {
      //slot=string
      if (isEmpty(state.profileData.payload.requests)) return undefined;
      if (isEmpty(state.profileData.payload.requests[request_id]))
        return undefined;
      return state.profileData.payload.requests[request_id].name;
      // return state.errors.filter(el => el.slot === slot);
    };
  },
  getRequestChassisNames(state) {
    return (request_id) => {
      //request_id=number
      let chassisNames = [];
      if (isEmpty(state.profileData.payload.requests)) return [];
      if (isEmpty(state.profileData.payload.requests[request_id])) return [];
      let chassis = state.profileData.payload.requests[request_id].chassis;

      for (const chas in chassis) {
        if (Object.hasOwnProperty.call(chassis, chas)) {
          // const chassisName = chassis[chas].name;
          chassisNames.push({
            chassis_id: chas,
            name: chassis[chas].name,
          });
        }
      }
      return chassisNames;
    };
  },
  getprofileDataRequestCount(state) {
    if (Object.keys(state.profileData.payload).length > 0) {
      return Object.keys(state.profileData.payload.requests).length;
    } else {
      return 0;
    }
  },
  /*  getRequestChassisCount(state) {
    return function(request_id) {
      return Object.keys(state.profileData.payload.requests).length;
    }; 
  },*/
  getNextRequest(state) {
    if (typeof state.profileData.payload != "undefined") {
      if (typeof state.profileData.payload.requests == "undefined") {
        return 1;
      } else {
        return Object.keys(state.profileData.payload.requests).length + 1;
      }
    }
  },
  getRequestCount(state) {
    if (typeof state.profileData.payload.requests != "undefined") {
      return Object.keys(state.profileData.payload.requests).length;
    } else {
      return 0;
    }
  },
  getChassisCount(state) {
    return (request_id) => {
      if (typeof state.profileData.payload.requests != "undefined") {
        return Object.keys(
          state.profileData.payload.requests[request_id].chassis
        ).length;
      } else {
        return 0;
      }
    };
  },
};

export const mutations = {
  resetProfileState(state) {
    Object.assign(state, defaultState());
  },

  setIsLoading(state, value) {
    state.isLoading = value;
  },

  setContactData(state, payload) {
    // console.log("setContact:", payload);

    Object.assign(state.profileData.contact, payload);
  },

  deleteProfileDataChassis(state, payload) {
    // request_id, chassis_id
    let chassisList = {};
    if (
      typeof state.profileData.payload.requests[payload.request_id].chassis[
        payload.chassis_id
      ] == "undefined"
    ) {
      return;
    } else {
      delete state.profileData.payload.requests[payload.request_id].chassis[
        payload.chassis_id
      ];
    }

    //rebuild chassis object
    if (
      Object.keys(
        state.profileData.payload.requests[payload.request_id].chassis
      ).length > 0
    ) {
      let i = 1;
      for (const ch in state.profileData.payload.requests[payload.request_id]
        .chassis) {
        if (
          state.profileData.payload.requests[
            payload.request_id
          ].chassis.hasOwnProperty(ch)
        ) {
          chassisList[i] =
            state.profileData.payload.requests[payload.request_id].chassis[ch];
          i++;
        }
      }
    }
    // console.log("new chassisList", chassisList);
    state.profileData.payload.requests[payload.request_id].chassis = JSON.parse(
      JSON.stringify(chassisList)
    );
  },

  deleteRequest(state, request_id) {
    if (Object.keys("state.profileData.payload.requests").length == 1) {
      //deleting last request
      // console.log("deleting last request");
      delete state.profileData.payload.requests;
    } else {
      let newRequests = {},
        i = 1;
      for (let request in state.profileData.payload.requests) {
        if (state.profileData.payload.requests[request].id != request_id) {
          newRequests[i] = state.profileData.payload.requests[request];
          newRequests[i].id = i;
          i++;
        }
      }

      state.profileData.payload.requests = JSON.parse(
        JSON.stringify(newRequests)
      );
    }
  },

  setTokenVersion(state, payload) {
    state.profileData.token = payload.token;
    state.profileData.version = payload.version;
  },
  setProfileData(state, payload) {
    // console.log("set profile data", JSON.parse(JSON.stringify(payload)));

    if (Array.isArray(payload)) {
      Object.assign(state.profileData.payload, payload);
    } else {
      Vue.set(state.profileData, "payload", payload);
    }

    // Vue.set(state.profileData, "payload", payload);
    // Object.assign(state.profileData.payload, payload);
  },
  setRequestName(state, { reqId, reqName }) {
    if (typeof state.profileData.payload.requests[reqId] == "undefined") return;
    Vue.set(state.profileData.payload.requests[reqId], "name", reqName);
  },
  setRequestDate(state, { reqId, reqDate }) {
    if (typeof state.profileData.payload.requests[reqId] == "undefined") return;
    Vue.set(state.profileData.payload.requests[reqId], "date", reqDate);
  },
  setRequestStatus(state, { reqId, reqStatus }) {
    if (typeof state.profileData.payload.requests[reqId] == "undefined") return;
    Vue.set(state.profileData.payload.requests[reqId], "status", reqStatus);
  },

  addRequest(state, { reqId, reqData }) {
    if (typeof state.profileData.payload.requests == "undefined") {
      // console.log("create requsts object");
      state.profileData.payload.requests = {};
    }
    state.profileData.payload.requests[reqId] = reqData;
  },
  modifyRequest(state, payload) {
    Vue.set(state.profileData.payload.requests, payload.reqId, payload.reqData);
  },

  // addChassis(request_id) {},
  delete_Chassis(state, payload) {
    //payload: request_id, chasssis_id
    delete state.profileData.payload.requests[payload.request_id].chassis[
      payload.chassis_id
    ];
  },
  add_Chassis(state, { reqId, chassisId, chassisData }) {
    //payload.reqId:number = add to which request id
    //payload.chassisId:number = chassis number to add/update
    //payload.chassisData:object = the data

    if (isEmpty(state.profileData.payload.requests[reqId])) {
      return;
    }
    Vue.set(
      state.profileData.payload.requests[reqId].chassis,
      chassisId,
      chassisData
    );
  },
  upgradeFR5chassis(state, { request_id, chassis_id }) {
    //change Fr5 frame from FR5 to NS-FR5

    let ch =
      state.profileData.payload.requests?.[request_id].chassis?.[chassis_id];
    if (ch) {
      if (ch.frame.model == "ULTRIX-FR5") {
        ch.frame.model = "ULTRIX-NS-FR5";
      }
      if (ch.frame.modules.macd?.model == "ACUFR-CPU") {
        ch.frame.modules.macd.model = "ACUFR5NS-CPU";
      }
      if (ch.frame.modules.macd?.type == "ACUFR-CPU") {
        ch.frame.modules.macd.type = "ACUFR5NS-CPU";
      }
      if (ch.name == "ULTRIX-FR5") {
        ch.name = "ULTRIX-NS-FR5";
      }
      state.profileData.payload.requests[request_id].status = "Upgraded";
    }
  },
};
export const actions = {
  loadProfileData({ commit, dispatch }, profile) {
    commit("setIsLoading", true);

    /* console.log(
      "profile vesion ",
      profile.version,
      " > UltrixData version ",
      UltrixData.dataVersion
    ); */
    if (
      profile.version != UltrixData.dataVersion ||
      UltrixData.dataVersion == "dev"
    ) {
      let newProfile = methods.updateProfileData(profile);
      commit("setTokenVersion", {
        token: newProfile.token,
        version: newProfile.version,
      });
      commit("setProfileData", newProfile.payload);
      commit("setContactData", newProfile.contact);
      dispatch("saveData");
    } else {
      commit("setTokenVersion", {
        token: profile.token,
        version: profile.version,
      });
      commit("setProfileData", profile.payload);
      commit("setContactData", profile.contact);
    }
  },

  saveData({ commit }) {
    return new Promise((resolve, reject) => {
      commit("setIsLoading", true);
      // console.log("saveData profile", state.profileData.payload);
      let token = state.profileData.token;
      let version = state.profileData.version;
      let profile = state.profileData.payload;
      // let self = this;
      api
        .saveProfile(token, version, profile)
        .then((response) => {
          // console.log("save resp:", response);
          // commit("setIsLoading", false);
          resolve(response);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log("save-error:" + error);
          // commit("setIsLoading", false);
          reject(error);
        })
        .finally(() => {
          commit("setIsLoading", false);
        });
    });
  },
  saveRequestName({ commit, dispatch }, payload) {
    commit("setRequestName", payload);
    commit("setRequestDate", { reqId: payload.reqId, reqDate: getTodayTime() });
    dispatch("saveData");
  },
  addRequest({ commit }, payload) {
    payload.reqData.date = getTodayTime();
    commit("addRequest", {
      reqId: payload.reqId,
      reqData: payload.reqData,
    });
  },
  modifyRequest({ commit }, payload) {
    commit("modifyRequest", {
      reqId: payload.reqId,
      reqData: payload.reqData,
    });
  },
  duplicateChassis({ commit, dispatch, getters }, { reqId, chassisId }) {
    //reqId:number = request # to copy from
    //chassisId:number = chassis # to duplicate
    commit("setIsLoading", true);
    //get reqID > chassisID
    let chassisCopy = JSON.parse(
      JSON.stringify(
        state.profileData.payload.requests[reqId].chassis[chassisId]
      )
    );
    //add chassis to next chassisId
    let nxt = getters.getChassisCount(reqId) + 1;
    chassisCopy.name += "_copy";
    commit("add_Chassis", {
      reqId: reqId,
      chassisId: nxt,
      chassisData: chassisCopy,
    });
    //save
    dispatch("saveData");
  },
  duplicateSystem({ commit, dispatch, getters }, { reqId }) {
    //reqId:number = request # to copy from

    commit("setIsLoading", true);

    let requestCopy = JSON.parse(
      JSON.stringify(state.profileData.payload.requests[reqId])
    );

    let newId = getters.getRequestCount + 1;
    requestCopy.name += "_copy";
    requestCopy.id = newId;
    requestCopy.date = getTodayTime();
    commit("addRequest", {
      reqId: newId,
      reqData: requestCopy,
    });

    //save
    // dispatch("saveData");
  },
};
